var map = {
	"./book.png": 640,
	"./gameOne.png": 918,
	"./gameTwo.png": 10,
	"./home.png": 404,
	"./logo-git.png": 267,
	"./logo-rs.png": 276,
	"./statistic.png": 752,
	"./team.png": 807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;